<template>
	<figure class="sanity-rich-text-component my-100 mx-0">
		<img v-lazy="imageUrl" :alt="props.value.alt" class="vertical-align-bottom" role="presentation" />
		<figcaption v-if="props.value.caption" class="figcaption" data-test="image-caption">{{
			props.value.caption
		}}</figcaption>
	</figure>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { generateSanityImageUrl } from '@utils/sanity/image-url-builder';
import { PortableTextComponentProps } from '@portabletext/vue';
import { SanityImageWithCaption } from 'types/sanity';
import { useSanityImage } from '@utils/composables/use-sanity-image';

type Props = PortableTextComponentProps<SanityImageWithCaption>;

const props = defineProps<Props>();

const baseImageUrl = computed(() => {
	if (props.value.url) {
		return props.value.url;
	}

	if (props.value.image) {
		return generateSanityImageUrl(props.value.image);
	}

	return '';
});

const imageUrl = useSanityImage(baseImageUrl.value);
</script>
